import { mockCustomer } from "../customer/customer.query";
import { mockCart } from "./../cart/mockCart";
import { PaymentType } from "@cart-app/generated/graphql";

export const mockPaymentMethods = [
  {
    __typename: "PaymentMethod" as const,
    type: "CREDIT_CARD" as PaymentType,
    description: "Add a new card",
    imageSrc: null,
  },
  {
    __typename: "PaymentMethod" as const,
    type: "PAYPAL" as PaymentType,
    description: "Pay Now or Pay in 4",
    imageSrc:
      "https://static.devcat.ch/static/catch/images/paypal/paypal-logo-color-71616c7db6.svg",
  },
  {
    __typename: "PaymentMethod" as const,
    type: "ZIPPAY" as PaymentType,
    description: "Own it now, pay later",
    imageSrc:
      "https://static.devcat.ch/static/catch/images/zippay/zippay-logo-color-63dc1f90ed.svg",
  },
  {
    __typename: "PaymentMethod" as const,
    type: "AFTERPAY" as PaymentType,
    description: "Shop Now, Pay Later, Interest-free",
    imageSrc:
      "https://static.devcat.ch/static/catch/images/afterpay/afterpay-logo-fb1e87d8d8.svg",
  },
  {
    __typename: "PaymentMethod" as const,
    type: "LATITUDEPAY" as PaymentType,
    description: "10 weekly payments. No interest. Ever.",
    imageSrc:
      "https://static.devcat.ch/static/catch/images/latitude-pay/latitude-pay-logo-color-stacked-fdda9a150f.svg",
  },
];

export const mockCheckout = {
  __typename: "Checkout" as const,
  id: "19be6892-4cd4-11ec-81d3-0242ac130003",
  // TODO: Create Notices mock
  notices: [],
  customer: mockCustomer,
  cart: mockCart,
  paymentMethods: mockPaymentMethods,
  selectedPaymentMethod: mockPaymentMethods[1],
  giftCardSupported: true,
  selectedAddress: {
    ...mockCustomer.addressBook.defaultAddress,
  },
  express: false,
};
